import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import {
  Component,
  AfterViewInit,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { SpinnerComponent } from '@mzic/mzic-components';

@Component({
  selector: 'lib-cancel-connection-dialog',
  imports: [CommonModule, A11yModule, TranslocoModule, SpinnerComponent],
  providers: [
    provideTranslocoScope({
      scope: 'mzic-collection-flow',
      alias: 'lang',
    }),
  ],
  templateUrl: './cancel-connection-dialog.component.html',
  styleUrl: './cancel-connection-dialog.component.scss',
})
export class CancelConnectionDialogComponent implements AfterViewInit {
  @Input() loading = false;

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  readonly titleId = 'cancel-connection-title';
  readonly descriptionId = 'cancel-connection-description';

  @ViewChild('backButton', { read: ElementRef })
  private backButton?: ElementRef<HTMLButtonElement>;

  ngAfterViewInit(): void {
    this.backButton?.nativeElement.focus();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent): void {
    if (this.loading) return;
    event.preventDefault();
    this.cancel.emit();
  }

  onOverlayClick(event: Event): void {
    if (!this.loading && event.target === event.currentTarget) {
      this.cancel.emit();
    }
  }

  onConfirm(): void {
    if (this.loading) return;
    this.confirm.emit();
  }

  onCancel(): void {
    if (this.loading) return;
    this.cancel.emit();
  }
}
